// 遷移アニメーション・ナビ背景などで共通利用（setting.scss の CSS 変数と同期）
export const PAGE_THEME_VAR = {
  home: '--color-blu',
  about: '--color-red',
  service: '--color-lblu',
  works: '--color-org',
  blog: '--color-grn',
  staff: '--color-pnk',
  contact: '--color-yel',
  privacy: '--color-yel',
  price: '--color-lblu',
};

export function normalizePathname(pathname) {
  if (!pathname) {
    return '/';
  }
  var path = pathname.split('?')[0].split('#')[0];
  if (path.length > 1 && path.charAt(path.length - 1) === '/') {
    path = path.slice(0, -1);
  }
  return path || '/';
}

export function getPageThemeKey(pathname) {
  var path = normalizePathname(pathname);

  if (path === '/') {
    return 'home';
  }
  if (path.indexOf('/about') === 0) {
    return 'about';
  }
  if (path.indexOf('/service') === 0) {
    return 'service';
  }
  if (path.indexOf('/works') === 0) {
    return 'works';
  }
  if (path.indexOf('/blog') === 0) {
    return 'blog';
  }
  if (path.indexOf('/staff') === 0) {
    return 'staff';
  }
  if (path.indexOf('/contact') === 0) {
    return 'contact';
  }
  if (path.indexOf('/privacy') === 0) {
    return 'privacy';
  }
  if (path.indexOf('/price') === 0) {
    return 'price';
  }

  return 'home';
}

export function getThemeColor(pathname) {
  var cssVar = PAGE_THEME_VAR[getPageThemeKey(pathname)] || PAGE_THEME_VAR.home;
  var color = getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
  return color || '#005AB4';
}
